// extracted by mini-css-extract-plugin
module.exports = {"root":"TranslationEditor_root__3DIkW","label":"TranslationEditor_label__3BWQu","editor":"TranslationEditor_editor__2fH4_"};